import React from "react";
import { LucideIcon } from "lucide-react";

interface BadgeProps {
  label: string;
  color?:
    | "default"
    | "red"
    | "yellow"
    | "green"
    | "blue"
    | "indigo"
    | "purple"
    | "pink";
  size?: "default" | "large";
  iconLeft?: LucideIcon;
  iconRight?: LucideIcon;
  full?: boolean;
  className?: string;
}

export function Badge({
  label,
  color = "default",
  size = "default",
  iconLeft: IconLeft,
  iconRight: IconRight,
  full = false,
  className,
}: BadgeProps) {
  const baseClasses = [
    "inline-flex",
    "items-center",
    "rounded-full",
    "font-medium",
    "ring-1",
    "ring-inset",
    "truncate",
    "min-w-0",
    "[&>span]:truncate",
  ];

  const colorClasses = {
    default: "bg-default-30 text-default-600 ring-default-600/10",
    red: "bg-red-50 text-red-700 ring-red-600/10",
    yellow: "bg-yellow-50 text-yellow-800 ring-yellow-600/20",
    green: "bg-green-50 text-green-700 ring-green-600/20",
    blue: "bg-blue-50 text-blue-700 ring-blue-700/10",
    indigo: "bg-indigo-50 text-indigo-700 ring-indigo-700/10",
    purple: "bg-default-50 text-default-700 ring-default-700/10",
    pink: "bg-pink-50 text-pink-700 ring-pink-700/10",
  };

  const sizeClasses = {
    default: "text-xs px-2 py-0.5 space-x-1 [&_svg]:w-3 [&_svg]:h-3",
    large: "text-sm px-2.5 py-1 space-x-2 [&_svg]:w-4 [&_svg]:h-4",
  };

  const classes = [
    ...baseClasses,
    colorClasses[color],
    sizeClasses[size],
    full ? "w-full" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes}>
      {IconLeft && (
        <span>
          <IconLeft />
        </span>
      )}
      <span>{label}</span>
      {IconRight && (
        <span>
          <IconRight />
        </span>
      )}
    </span>
  );
}
